const replaceUrlParams = (url, params) => {
  const paramMatch = /(\/)(:[\w|-]+)/gi;

  if (!params || !params.length) {
    return url;
  }

  return params.reduce((url, param) => {
    return url.replace(paramMatch, `$1${param}`);
  }, url);
};

const formatQueryParams = (queryParams) => {
  if (!queryParams) return '';

  const hasQuestionMark = queryParams.indexOf('?') > -1;
  const prefix = !hasQuestionMark ? '?' : '';

  return prefix + queryParams;
};

export const createUrl = (route, params = [], options = {}) => {
  const queryParams = formatQueryParams(options.queryParams);
  const url = replaceUrlParams(route, params);

  return url + queryParams;
};
